module.exports = __webpack_public_path__ + "static/media/headerbg.c1918347.png";